import React from 'react'
import { Link } from 'react-router-dom'
import config from '../Config'

const avatarColors = ['#A44CD7', '#0CACC2', '#F55145', '#F9BE22', '#8A3BBD', '#19C37D', '#5A79DF', '#EC2434']
const getInitials = (name = '') => name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)

const StaffTable = ({ data, onDelete, checkAccess }) => {

    return (
        <div className='table-responsive'>
            <table className='jean-table table'>
                <tbody>
                    {data?.map((staff, index) => {
                        return (
                            <tr key={staff.userKey}>
                                <td>
                                    <div className="rounded-circle d-flex align-items-center justify-content-center"
                                        style={{ width: 46, height: 46, background: avatarColors[index % avatarColors.length], color: '#fff', fontWeight: 700, fontSize: 15 }}>
                                        {getInitials(staff.name)}
                                    </div>
                                </td>

                                <td>
                                    <div className='therapist-info'>
                                        <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Name</p>
                                        <p className='mb-0'>{staff.name}</p>
                                    </div>
                                </td>

                                <td>
                                    <div className='therapist-info'>
                                        <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Email</p>
                                        <p className='mb-0'>{staff.email}</p>
                                    </div>
                                </td>

                                <td>
                                    <div className='therapist-info'>
                                        <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Mobile No.</p>
                                        <p className='mb-0'>{staff.phone}</p>
                                    </div>
                                </td>

                                <td>
                                    <div className='therapist-info'>
                                        <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Role</p>
                                        <p className='mb-0'>{staff.role}</p>
                                    </div>
                                </td>

                                <td className='pe-3'>
                                    <div className='action-buttons'>
                                        {checkAccess && checkAccess(6, 3) && staff.role !== "Super Admin" &&
                                            <Link className="ps-dropdown__toggle bg-green fs-4 px-3 text-white py-2 border-0 me-3"
                                                to={`${config.appUrl}edit-staff/${staff.userKey}`}>
                                                <i className="icon-pen"></i>
                                            </Link>
                                        }
                                        {checkAccess && checkAccess(6, 4) && staff.role !== "Super Admin" &&
                                            <button className='ps-dropdown__toggle bg-red fs-4 px-3 text-white py-2 border-0'
                                                onClick={() => onDelete(staff.userKey)}>
                                                <i className="icon-trash2 text-white"></i>
                                            </button>
                                        }
                                    </div>
                                </td>
                            </tr>
                        )
                    })}

                    {data?.length === 0 &&
                        <tr><td colSpan={6}><div className="alert alert-success ps-4">No Staff Found !!</div></td></tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default StaffTable
